import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2 } from "lucide-react";
import PasswordInput from "@/components/PasswordInput";

// Separate sign-in from both employees and consultants, as agreed.
export default function StaffingLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/staffing/login", { email, password });
      window.location.href = "/staffing/portal";
    } catch (err) { setError(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-9 w-9 rounded-md bg-emerald-600 grid place-items-center">
            <Building2 className="h-5 w-5 text-white" strokeWidth={1.75} />
          </div>
          <div>
            <div className="font-semibold">Arborvitae</div>
            <div className="text-xs text-zinc-500">Contractor portal</div>
          </div>
        </div>

        <h1 className="text-xl font-semibold mb-1">Sign in</h1>
        <p className="text-sm text-zinc-500 mb-5">
          Use the email address Arborvitae has on file for you.
        </p>

        {error ? (
          <div className="mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700"
               data-testid="staff-login-error">{error}</div>
        ) : null}

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} autoFocus autoComplete="username"
                   onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <PasswordInput id="password" value={password} autoComplete="current-password"
                   onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="staff-login-submit">
            {busy ? "Signing in..." : "Sign in"}
          </Button>
        </form>

        <p className="text-xs text-zinc-500 mt-6">
          Trouble signing in? Email support@arborvitae.in.
        </p>
      </div>
    </div>
  );
}
